import { render, staticRenderFns } from "./departments_new.vue?vue&type=template&id=4471c580&scoped=true&"
import script from "./departments_new.vue?vue&type=script&lang=js&"
export * from "./departments_new.vue?vue&type=script&lang=js&"
import style0 from "./departments_new.vue?vue&type=style&index=0&id=4471c580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4471c580",
  null
  
)

export default component.exports